// extracted by mini-css-extract-plugin
export default {"AccordionTitle":"AccordionTitle_AccordionTitle__WByZ5","Image":"AccordionTitle_Image__I1DGh"};